module.exports = __webpack_public_path__ + "entry-150bfe9b/sap-photo-7b3626ece01bce9895d04e55198f705f.webp";